import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { PaginatedResponse } from "../../../core/http/paginated-response.type";
import { QueryParams } from "../../../core/http/query-params.type";
import { DEFAULT_QUERY_PARAMS } from "../../../shared/constants/services";
import { AnyObject } from "../../../shared/types/app.type";
import { UserInfo } from "../../../shared/types/user-info";
import { setEmptyStringsToNull } from "../../../shared/utils/objects/object";
import { InternalProvider } from "./internal-provider.type";

@Injectable({
  providedIn: "root",
})
export class InternalProviderService {
  path = "/internal-providers";
  basePath = `${environment.serverUrl}/internal-providers`;
  currentUser: UserInfo;
  basePathCsvQueue = `${this.basePath}/queue-csv`;

  constructor(private readonly http: HttpClient, private readonly authenticationService: AuthenticationService) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  createInternalProvider(values: AnyObject): Observable<InternalProvider> {
    return this.http.post<InternalProvider>(`${this.basePath}`, values).pipe(
      tap((_data: InternalProvider) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  updateInternalProvider(id: string, values: AnyObject): Observable<InternalProvider> {
    setEmptyStringsToNull(values);
    return this.http.put<InternalProvider>(`${this.basePath}/${id}`, values).pipe(
      tap((_data: InternalProvider) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getInternalProviders(options?: QueryParams<InternalProvider>): Observable<PaginatedResponse<InternalProvider>> {
    let params: HttpParams = new HttpParams();

    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }

    return this.http.get<PaginatedResponse<InternalProvider>>(this.basePath, { params }).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getInternalProvider(id: string): Observable<InternalProvider> {
    return this.http.get<InternalProvider>(`${this.basePath}/${id}`).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>("")),
    );
  }

  getInternalProvidersQueue(options?: QueryParams<InternalProvider>): Observable<void> {
    let params: HttpParams = new HttpParams();
    options = { ...DEFAULT_QUERY_PARAMS, ...options };
    for (const key in options) {
      if (options[key]) {
        params = params.set(key, JSON.stringify(options[key]));
      }
    }

    return this.http.get<void>(this.basePathCsvQueue, { params }).pipe(
      tap((_data) => console.log()),
      catchError(this.handleError<any>()),
    );
  }
  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return throwError(error);
    };
  }
}
